var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoundLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 43",
    style: {
      enableBackground: "new 0 0 48 43"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#13B5EA;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9 5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.5,0C7.4,0,0,7.4,0,16.5C0,25.6,7.4,33,16.5,33C25.6,33,33,25.6,33,16.5C33,7.4,25.6,0,16.5,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.8,13.2c-0.6-0.4-1.3-0.6-2-0.6c-0.8,0-1.5,0.2-2.2,0.7c-1,0.7-1.6,1.8-1.6,3c0,0.3,0,0.6,0.1,0.9 c0.4,1.4,1.7,2.5,3.2,2.7c0.1,0,0.3,0,0.4,0c0.3,0,0.6,0,0.9-0.1c0.4-0.1,0.8-0.2,1.1-0.5c0.3-0.2,0.6-0.5,1-0.9l0,0 c0.1-0.1,0.2-0.3,0.1-0.5c0-0.1-0.1-0.3-0.2-0.3c-0.1-0.1-0.2-0.1-0.3-0.1c-0.1,0-0.3,0-0.4,0.2l0,0c-0.1,0.1-0.1,0.1-0.2,0.2 c-0.2,0.2-0.5,0.4-0.7,0.6c-0.4,0.2-0.8,0.3-1.2,0.3c-1.4,0-2.2-0.9-2.5-1.7c-0.1-0.1-0.1-0.3-0.1-0.4c0,0,0,0,0,0l5.2,0 c0.4,0,0.7-0.1,0.9-0.4c0.2-0.2,0.2-0.5,0.2-0.8C18.3,14.5,17.7,13.7,16.8,13.2z M12.2,15.6c0.3-1.1,1.4-1.9,2.6-1.9 c1.2,0,2.3,0.8,2.6,1.9H12.2z M25.9,15.3c-0.5,0-1,0.4-1,0.9c0,0.5,0.4,0.9,1,0.9c0.5,0,1-0.4,1-0.9 C26.8,15.7,26.4,15.3,25.9,15.3z M22.5,13.2c0-0.3-0.2-0.5-0.5-0.5l-0.2,0c-0.5,0-0.9,0.1-1.3,0.4c-0.1-0.2-0.3-0.4-0.5-0.4 c-0.3,0-0.5,0.2-0.5,0.5l0,6.1c0,0.3,0.2,0.5,0.5,0.5c0.3,0,0.5-0.2,0.5-0.5v-3.7c0-1.2,0.1-1.7,1.2-1.8c0.1,0,0.2,0,0.2,0 C22.2,13.7,22.5,13.5,22.5,13.2z M8.2,16.2l2.8-2.7c0.1-0.1,0.2-0.2,0.2-0.4c0-0.3-0.2-0.5-0.5-0.5c-0.1,0-0.3,0.1-0.4,0.2 l-2.8,2.7l-2.8-2.7c-0.1-0.1-0.2-0.2-0.4-0.2c-0.3,0-0.5,0.2-0.5,0.5c0,0.1,0.1,0.3,0.2,0.4l2.8,2.7L3.9,19 c-0.1,0.1-0.2,0.2-0.2,0.4c0,0.3,0.2,0.5,0.5,0.5c0.1,0,0.3-0.1,0.4-0.2L7.5,17l2.8,2.7c0.1,0.1,0.2,0.2,0.4,0.2 c0.3,0,0.5-0.2,0.5-0.5c0-0.1-0.1-0.3-0.2-0.4L8.2,16.2z M25.9,12.6c-2.1,0-3.7,1.6-3.7,3.6c0,2,1.7,3.6,3.7,3.6 c2.1,0,3.7-1.6,3.7-3.6C29.6,14.2,27.9,12.6,25.9,12.6z M25.9,18.8c-1.4,0-2.6-1.1-2.6-2.6c0-1.4,1.2-2.6,2.6-2.6 c1.4,0,2.6,1.1,2.6,2.6C28.5,17.6,27.3,18.8,25.9,18.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundLogo);
export default __webpack_public_path__ + "static/media/round-logo.8560e6de21031171ed7a27e02a61b5a4.svg";
export { ForwardRef as ReactComponent };